import PropTypes from 'prop-types';
import SimpleCardList from 'components/SimpleCardList';
import { getCMSDocumentSrc } from 'utils/getCMSDocumentSrc';

/**
 * Lista de cards simple. SimpleCardList internamente renderiza un stack
 * de cards; en desktop lo centramos con max-w para evitar estiramiento.
 */
const SimpleCardListBlock = ({ value }) => (
  <section className='cms-block cms-block--simple-card-list py-6 md:py-6 lg:py-8'>
    <div className='w-full md:max-w-3xl lg:max-w-5xl mx-auto px-6'>
      <SimpleCardList
        title={value?.title || ''}
        cards={(value?.items || []).map((item) => ({
          id: item.id,
          ...item.value,
          image: item?.value?.image?.hash ? getCMSDocumentSrc(item.value.image) : null,
        }))}
      />
    </div>
  </section>
);

SimpleCardListBlock.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,
};

export default SimpleCardListBlock;
